// Column sets for the four Retention sidebar lists (RETENTION_WORKFLOW.md §2.4).
// Field names are the proposed API response keys — agree them with the backend before wiring.

export const TODAY_TASKS_HEAD = [
  { field: 'student_name', headerName: 'Student', width: 220 },
  { field: 'admn_no', headerName: 'Adm No', width: 130 },
  { field: 'stage_label', headerName: 'Current stage', width: 200 },
  { field: 'pending_update', headerName: 'Pending update', width: 300, toolTipGetter: true },
  { field: 'waiting_on_label', headerName: 'Waiting on', width: 130 },
  { field: 'due_label', headerName: 'Due', width: 160 },
  { field: 'last_updated', headerName: 'Last updated by · on', width: 240 },
  { field: 'open_workspace', headerName: 'Action', width: 140, type: 'action', actionType: 'view', actionKey: 'open', buttonName: 'Open' },
];

export const REPORTS_HEAD = [
  { field: 'student_name', headerName: 'Student', width: 220 },
  { field: 'admn_no', headerName: 'Adm No', width: 130 },
  { field: 'stage_label', headerName: 'Stage', width: 170 },
  { field: 'report_label', headerName: 'Report', width: 220 },
  { field: 'author_name', headerName: 'By', width: 170 },
  { field: 'submitted_at', headerName: 'Submitted', width: 160 },
  { field: 'status_label', headerName: 'Status', width: 200 },
  { field: 'headline_result', headerName: 'Result', width: 200 },
  { field: 'open_workspace', headerName: 'Action', width: 140, type: 'action', actionType: 'view', actionKey: 'open', buttonName: 'Open' },
];

export const RETAINED_HEAD = [
  { field: 'student_name', headerName: 'Student', width: 220 },
  { field: 'admn_no', headerName: 'Adm No', width: 130 },
  { field: 'renewal_date', headerName: 'Renewal date', width: 150 },
  { field: 'course_level', headerName: 'Course / level', width: 220 },
  { field: 'sessions_purchased', headerName: 'Sessions', width: 110 },
  { field: 'renewal_amount', headerName: 'Renewal amount', width: 160 },
  { field: 'retained_same_tutor_label', headerName: 'Same tutor', width: 130 },
  { field: 'upsell', headerName: 'Upsell', width: 180 },
  { field: 'referral_given_label', headerName: 'Referral', width: 110 },
  { field: 'open_workspace', headerName: 'Action', width: 140, type: 'action', actionType: 'view', actionKey: 'open', buttonName: 'View' },
];

export const EXITED_HEAD = [
  { field: 'student_name', headerName: 'Student', width: 220 },
  { field: 'admn_no', headerName: 'Adm No', width: 130 },
  { field: 'exit_type_label', headerName: 'Exit type', width: 150 },
  { field: 'primary_reason', headerName: 'Primary reason', width: 200 },
  { field: 'details', headerName: 'Details', width: 260, toolTipGetter: true },
  { field: 'course_inactive_date', headerName: 'Inactive from', width: 150 },
  { field: 'winback_or_return', headerName: 'Win-back / return', width: 220 },
  { field: 'followup_date', headerName: 'Follow-up', width: 140 },
  { field: 'open_workspace', headerName: 'Action', width: 140, type: 'action', actionType: 'view', actionKey: 'open', buttonName: 'View' },
];
